/**************************************************************************************************************************************************
*   MODULE NAME     :  Dashboard
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  11-02-2021
*   DESCRIPTION     :  Component to load Dashboard page
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/
import React from "react";
import { Container, Row, Col, Form, Tooltip, OverlayTrigger, Button, Tabs, Tab, Card, Popover } from "react-bootstrap";
import { FaSpinner, FaEye, FaFilter, FaExclamationTriangle, FaTimes } from "react-icons/fa";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import swal from "sweetalert";
import { loadGlobalDashboardData, loadGlobalDashboardDetails, sendJapanDashboardEmail, sendGlobalDashboardEmail } from "../../actions/homeActions";
import { loadAllAlerts } from "../../actions/abstractActions";
import { ddmmmyyyyFormat } from "../common/DateFormat";
import { EMAIL_SUCCESSFULL, EMAIL_UNSUCCESSFULL, UNSUCCESSFUL_EMAIL_LIST} from '../common/MessagesPool';
import DataTable from "../common/dataTable/DataTable";
import DashboardTab from "./DashboardTab";
import Loader from "../common/Loader"
import "./Dashboard.css";

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.GLOBAL = 'global';
    this.JAPAN = 'japan';
    this.DUPLICATE = 'Duplicate';
    this.state = {
      isLoading: false,
      globalEmails: "",
      japanEmails: "",
      validation: {
        globalEmails: false,
        japanEmails: false
      },
      detailTite: "",
      activeTab: "dashboard",
      tabList: [],
      alertMasterData: {},
      globalDashboardData: new Array(9).fill(0),
      japanDashboardData: new Array(8).fill(0),
      globalTitles: ["Global Abstract To Review", "Global Duplicates To Review", "Global Article To Review", "Global Article To Order", "Global Article Ordered(Non-Valid)", "Global Article Ordered Valid", "Global Cases To Process", "Global Translation Requested", "Global Submission Needed"],
      japanTitles: ["Japan Abstract To Review", "Japan Duplicates To Review", "Japan Article To Review", "Japan Article To Quality Review", "Japan Article To Order", "Japan Article Ordered", "Japan Cases To Process", "Japan Research To Quality Review"],
    }
  }
  /**
   * Function to hide/show loader.
   * @param isLoading whether to hide or show loader
   */
  setLoader = isLoading => this.setState({ isLoading });
  /**
   * Function to initiate life cycle hooks.
   */
  componentDidMount() {
    this.loadAlertsData();
    this.setLoader(true);
    this.props.loadGlobalDashboardData().then(res => {
      let data = res.data;
      this.setState({
        globalDashboardData: data.result.globalCounts,
        japanDashboardData: data.result.japanCounts
      }, () => this.setLoader(false))
    }).catch(error => {
      this.setLoader(false);
    });
  }
  loadAlertsData = async () => {
    this.setLoader(true);
    try {
      let response = await this.props.loadAllAlerts();
      let alertMasterData = {};
      response.data.result.map((e) => {
        alertMasterData[e.masterDataKey] = e.masterDataValue
      })
      this.setState(prevState => ({
        alertMasterData: alertMasterData,
      }));
    } catch (error) {
      this.setLoader(false)
    }
  }
  handleChange = (e) => {
    let { name, value} = e.target;
    let validation = !this.checkEmailValidation(value);
    this.setState((prevState) => ({
        [name]: value,
        validation: {
          ...prevState.validation,
          [name]: validation
        }
      }
    ))
  }

  checkEmailValidation = (str) => {
    function validateEmail(email) {
        var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
        return re.test(email);
    }
    if(str.trim() === '') return true;
    var emails = str.trim().split(';').map(e => e.trim()).filter(e => e !== '');

    return emails.length > 0 && !emails.some(email => !validateEmail(email));
  }  

  handleGlobalSubmitFunction = async () => {
    this.setLoader(true);
    let {globalEmails} = this.state;
    let emails = globalEmails.trim().split(';').map(e => e.trim()).filter(e => e !== '');
    let payload = {
      toEmail: emails,
      ccEmail: ''
    };
    let res = await this.props.sendGlobalDashboardEmail(payload);
    if(res && res.data && res.data.result && res.data.result.length === 0) {
      swal('Success', EMAIL_SUCCESSFULL, 'success')
      this.setState({
        globalEmails: ''
      });
    } else if(res && res.data && res.data.result && res.data.result.length > 0 ){
      let errorEmails = res.data.result;
      swal('Error', UNSUCCESSFUL_EMAIL_LIST + " : " + errorEmails.join(", "), 'error')
    } else {
      swal('Error', EMAIL_UNSUCCESSFULL, 'error')
    }
    this.setLoader(false);
  }
  handleJapanSubmitFunction = async () => {
    let {japanEmails} = this.state;
    let emails = japanEmails.trim().split(';').map(e => e.trim()).filter(e => e !== '');
    let payload = {
      toEmail: emails,
      ccEmail: ''
    };
    let res = await this.props.sendJapanDashboardEmail(payload);
    if(res && res.data && res.data.result && res.data.result.length === 0) {
      swal('Success', EMAIL_SUCCESSFULL, 'success')
      this.setState({
        japanEmails: ''
      });
    } else {
      swal('Error', EMAIL_UNSUCCESSFULL, 'error')
    }
    this.setLoader(false);
  }

  handleDashboardDetails = async (datatype, site) => {
    let { tabList } = this.state;
    let dashboardTitles = site === this.GLOBAL ? this.state.globalTitles : this.state.japanTitles;
    let title = dashboardTitles[datatype];
    if (tabList.find(e => e.title === title)) {
      this.setState({
        activeTab: title,
      })
      return;
    } else {
      this.setState({
        activeTab: title,
        tabList: [...tabList, { title, datatype, site }]
      })
    }
  }
  handleTabChange = (key) => {
    this.setState({
      activeTab: key
    })
  }
  deleteTab = async (title, datatype, site) => {
    let dashboardDetails = { ...this.state.dashboardDetails };
    let tabList = this.state.tabList.filter(e => e.title !== title);
    delete dashboardDetails[title];
    await this.setState({
      dashboardDetails: dashboardDetails,
      tabList: tabList,
    })
    await this.setState({
      activeTab: "dashboard"
    })
  }
  


  render() {
    const { isLoading, globalEmails, japanEmails, validation} = this.state;
    const disabledGlobal = (globalEmails === null || globalEmails.trim() === "" || validation.globalEmails );
    const disabledJapan = (japanEmails === null || japanEmails.trim() === "" || validation.japanEmails );
    const {
      globalDashboardData,
      globalTitles,
      japanTitles,
      japanDashboardData,
      activeTab,
    } = this.state;
    return (
      <>
        <table className="print-table">
          <thead>
            <tr>
              <td>
                <div className="page-header-space"></div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div className="CommonWrap dashboardWrap">
                  <Container fluid>
                    <Tabs id="addAbstractTab" activeKey={activeTab} onSelect={key => this.handleTabChange(key)} transition={false}>
                      <Tab eventKey="dashboard" title="Dashboard">
                        <div className="dashboard-wrap">
                          <Row>
                            <Col sm="6" className="pl-0 pr-0">
                              <div className="dashboard-section mr-3">
                                <h2>Global Dashboard</h2>
                                <ul className="listWrap">
                                  <li className="tableHead">
                                    <strong className="title">Category</strong>
                                    <strong className="counts">Count</strong>
                                  </li>
                                  {globalTitles.map((title, index) => (
                                    <li className="tableBody" key={index}>
                                      <span className="title">{title}</span>
                                      <span className="underlinelink counts" onClick={() => this.handleDashboardDetails(index, this.GLOBAL)}>{globalDashboardData[index]}</span>
                                    </li>
                                  ))}
                                </ul>
                                <div className="mail-section">
                                  <Form>
                                    <Row>
                                      <Col sm={{ span: 6, offset: 2 }} className="pr-0">
                                        <Form.Group controlId="globalEmails">
                                          <Form.Label>Enter Email ID<span className="mandatory">*</span></Form.Label>
                                          <Form.Control type="text" name="globalEmails"
                                            value={globalEmails} onChange={this.handleChange} required
                                            isInvalid={validation.globalEmails}
                                          />
                                          <Form.Control.Feedback type="invalid">
                                              Invalid Format.
                                          </Form.Control.Feedback>
                                        </Form.Group>
                                      </Col>
                                      <Col sm={3} className="mt-20">
                                        <Button variant="primary" type="button" onClick={this.handleGlobalSubmitFunction} disabled={disabledGlobal}>
                                          Send Mail
                          </Button>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col className="text-center">
                                      To send email to multiple persons, enter email ID seperated by semi-colon(;).
                        </Col>
                                    </Row>
                                  </Form>
                                </div>
                              </div>
                            </Col>
                            <Col sm="6" className="pl-0 pr-0">
                              <div className="dashboard-section ml-3">
                                <h2>Japan Dashboard</h2>
                                <ul className="listWrap">
                                  <li className="tableHead">
                                    <strong className="title">Category</strong>
                                    <strong className="counts">Count</strong>
                                  </li>
                                  {japanTitles.map((title, index) => (
                                    <li className="tableBody" key={index}>
                                      <span className="title">{title}</span>
                                      <span className="underlinelink counts" onClick={() => this.handleDashboardDetails(index, this.JAPAN)}>{japanDashboardData[index]}</span>
                                    </li>
                                  ))}

                                </ul>
                                <div className="mail-section">
                                  <Form>
                                    <Row>
                                      <Col sm={{ span: 6, offset: 2 }} className="pr-0">
                                        <Form.Group controlId="japanEmails">
                                          <Form.Label>Enter Email ID<span className="mandatory">*</span></Form.Label>
                                          <Form.Control type="text" name="japanEmails"
                                            value={japanEmails} onChange={this.handleChange} required
                                            isInvalid={validation.japanEmails}
                                          />
                                          <Form.Control.Feedback type="invalid">
                                              Invalid Format.
                                          </Form.Control.Feedback>
                                        </Form.Group>
                                      </Col>
                                      <Col sm={3} className="mt-20">
                                        <Button variant="primary" type="button" onClick={this.handleJapanSubmitFunction} disabled={disabledJapan}>
                                          Send Mail
                          </Button>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col className="text-center">
                                      To send email to multiple persons, enter email ID seperated by semi-colon(;).
                        </Col>
                                    </Row>
                                  </Form>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Tab>
                      {
                        this.state.tabList.map((tabObject) => (
                          <Tab eventKey={tabObject.title} key={tabObject.title} title={(<span>{tabObject.title} <FaTimes className="closeTab" onClick={() => this.deleteTab(tabObject.title, tabObject.datatype, tabObject.site)} /> </span>)}>
                            <DashboardTab
                              title={tabObject.title}
                              datatype={tabObject.datatype}
                              site={tabObject.site}
                              alertMasterData={this.state.alertMasterData}
                            />
                          </Tab>
                        ))
                      }
                    </Tabs>


                  </Container>
                </div>
                {isLoading && (
                  <div className="loader">
                    <FaSpinner />
                  </div>
                )}
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>
                <div className="page-footer-space"></div>
              </td>
            </tr>
          </tfoot>
        </table>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      loadGlobalDashboardData,
      loadGlobalDashboardDetails,
      loadAllAlerts,
      sendJapanDashboardEmail,
      sendGlobalDashboardEmail
    },
    dispatch
  );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Dashboard));
